import React from 'react';
import { Link } from 'react-router-dom';

const BygGaranti = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
        <img 
          src="/media/billeder/Badeværelse/IMG_3373.jpeg" 
          alt="Background" 
          className="absolute inset-0 w-full h-full object-cover opacity-90"
        />
        
        <div className="relative z-10 text-center text-white px-4 max-w-5xl mx-auto py-20">
          <h1 className="text-4xl md:text-6xl font-bold uppercase mb-6 text-shadow-strong">
            Murermester Voss
          </h1>
          
          <div className="text-2xl md:text-3xl mb-8 text-shadow-strong">
            <p className="font-bold">DANSK BYG GARANTI - DIN SIKKERHED</p>
          </div>

          <Link to="/kontakt" className="inline-block mb-8">
            <button className="btn-primary text-xl px-8 py-4">KONTAKT</button>
          </Link>

          <div className="bg-primary bg-opacity-60 backdrop-blur-sm rounded-3xl p-8 text-shadow">
            <p className="text-lg md:text-xl leading-relaxed">
              KUN VIRKSOMHEDER, DER ER MEDLEM AF DANSK BYGGERI,
              <br />ER DÆKKET AF BYG GARANTI
              <br /><br />
              Byg Garanti er et økonomisk sikkerhedsnet under de private forbrugere,
              <br />hvis der er fejl og mangler ved det arbejde,
              <br />som er aftalt med en byggevirksomhed der er medlem af Dansk Byggeri.
              <br /><br />
              Ordningen dækker med op til 100.000 kr. inkl. moms* pr. byggesag.
              <br />Efter arbejdet er færdigt,
              <br />dækker garantien i op til tre år for synlige fejl og op til ti år for skjulte fejl og mangler.
            </p>
          </div>
        </div>
      </section>

      {/* Coverage Section */}
      <section className="bg-gray-100 py-16">
        <div className="section-container">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-8">
              BYG GARANTI DÆKKER ARBEJDE,
              <br />DER ER UDFØRT FOR PRIVATE
              <br />KUNDER PÅ DERES PRIVATE BOLIG
            </h2>

            <div className="text-lg text-left space-y-4 mb-8">
              <p>• En- eller to-familieboliger</p>
              <p>• Forbrugerens egen ejerlejlighed eller andelsbolig</p>
              <p>• Sommerhuse</p>
              <p>• Privatbolig i forbindelse med blandet bolig- og erhvervsejendomme, herunder stuehuse til landbrug</p>
              <p>• Lejeboliger, hvis arbejdet bestilles og betales af lejeren selv</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/kontakt">
                <button className="btn-primary">Kontakt os</button>
              </Link>
              <a href="tel:+4528588607">
                <button className="btn-primary">+45 2858 8607</button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BygGaranti;
